import { KeyboardEvent, useMemo, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';

interface Props {
  onConfirm: (count: number) => void;
}

const MIN_COUNT = 1;
const MAX_COUNT = 100;
const INTEGER_ONLY_REGEXP = /^\d*$/;
const INVALID_NUMBER_KEYS = ['e', 'E', '+', '-', '.'];

const InitialWorkCountCard: React.FC<Props> = ({ onConfirm }) => {
  const [value, setValue] = useState<string>('1');
  const count = value === '' ? NaN : Number(value);

  const validationMessage = useMemo(() => {
    if (!Number.isInteger(count) || count < MIN_COUNT) return `${MIN_COUNT}以上を入力してください。`;
    if (count > MAX_COUNT) return `${MAX_COUNT + 1}件以上の場合は${MAX_COUNT}をご入力の上、この先の「追加」ボタンで入力欄を追加してご入力ください。`;
    return '';
  }, [count]);

  const disabledConfirm = validationMessage !== '';

  const handleChange = (inputValue: string) => {
    if (!INTEGER_ONLY_REGEXP.test(inputValue)) return;
    setValue(inputValue);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (INVALID_NUMBER_KEYS.includes(event.key)) event.preventDefault();
  };

  return (
    <Card className="work-card initial-work-count-card mb-3 mx-auto">
      <Card.Body>
        <h6>この媒体から送信した著作物（図やイラスト等）の数をご入力ください。</h6>
        <Row className="align-items-end">
          <Col md={6}>
            <Form.Control
              type="number"
              inputMode="numeric"
              min={MIN_COUNT}
              max={MAX_COUNT}
              step={1}
              value={value}
              onChange={(event) => handleChange(event.currentTarget.value)}
              onKeyDown={handleKeyDown}
            />
          </Col>
          <Col md={6} className="text-right">
            <Button variant="primary" onClick={() => onConfirm(count)} disabled={disabledConfirm}>
              著作物入力へ進む
            </Button>
          </Col>
        </Row>
        {validationMessage && <div className="text-danger mt-2">{validationMessage}</div>}
      </Card.Body>
    </Card>
  );
};

export default InitialWorkCountCard;
